<div class="btn-group">
    <button *ngIf="visible" type="button" class="btn btn-primary round {{class}}"
      placement="bottom" container="body" [ngbTooltip]="tooltip|translate" (click)="onBtnClick($event)">
      <i class="fas fa-plus"></i>
    </button>
</div>
